'use strict'

import {
  isNumericRouteId,
  isPublicRouteId
} from '../common/routeRecordId'

/**
 * 旧画面が一覧行オブジェクトや一時的なprojectIdをroute paramsへ渡しても、
 * 遷移直後にレコード参照をURLへ残す。
 *
 * <p>数値IDは後続PublicRouteReferenceGuardがUUIDへ置換する。既にUUIDがある場合は
 * 数値へ戻さない。変換後の画面はAPIから再取得するため、F5・ブックマーク・
 * 別タブでも同じレコードを復元できる。</p>
 */
export default function installRecordRoutePersistenceGuard (router) {
  if (!router || router.__preikaRecordRoutePersistenceInstalled) return
  router.__preikaRecordRoutePersistenceInstalled = true

  router.beforeEach((to, from, next) => {
    const params = (to && to.params) || {}
    const query = (to && to.query) || {}

    // 既にURLへ永続化された数値またはUUIDがある通常遷移は変更しない。
    if (normalizeReference(params.id) || normalizeReference(query.id)) {
      next()
      return
    }

    const value = params.value || {}
    const reference = normalizeReference(value.public_id) ||
      normalizeReference(value.publicId) ||
      normalizeReference(value.id) ||
      normalizeReference(params.projectId)
    if (!reference || !to.name) {
      next()
      return
    }

    const target = {
      name: to.name,
      params: { ...params },
      query: { ...query },
      hash: to.hash,
      replace: true
    }
    delete target.params.value
    delete target.params.projectId

    if (routeHasIdParameter(to)) {
      target.params.id = reference
    } else {
      target.query.id = reference
    }
    next(target)
  })
}

function routeHasIdParameter (route) {
  const matched = (route && route.matched) || []
  return matched.some(record => /(^|\/):id(?:\([^)]*\))?(?:\/|$)/.test(record.path || ''))
}

function normalizeReference (value) {
  const text = String(value == null ? '' : value).trim()
  if (isPublicRouteId(text)) return text.toLowerCase()
  if (isNumericRouteId(text)) return String(Number(text))
  return null
}
